<template>
  <div class="item" id="about1">
    <div class="item-header">
      <div class="item-header-title">OUR CUSTOMERS</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>公司</span>
        <span class="bold">介绍</span>
        <span class="item-header-name-line" />
      </div>
    </div>

    <div class="item-content">
      <div class="info info-one">
        <span>公司简介</span>
        <p>安易信科技作为数字化转型解决方案新型服务提供商，致力于帮助医疗、企业、金融等行业客户实现业务数字化转型并成为客户IT服务领域最信赖的合作伙伴。安易信科技拥有云计算、数据库、虚拟化、数据存储、网络互联、信息安全、物联网、边缘计算、5G应用等数字化基础设施全专业的技术服务能力。</p>
        <p>安易信科技目前员工100多人，包括杭州总部、温州、台州、嘉兴、金华分公司及客户常驻人员，为我们的客户是提供快速高效的服务。</p>
        <p>安易信科技核心团队拥有15+年的从业经验，已服务200+医疗数据中心建设案例、100+大中型企业数据中心建设案例、100+其他行业数据中心建设案例，并由此积累和沉淀了最核心技术服务知识库。</p>
        <p>安易信核心团队拥有15年+的从业经验，已服务200+医疗数据中心建设案例、100+大中型企业数据中心建设案例、100+其他行业数据中心建设案例</p>
        <div class="item-btn">联系我们</div>
      </div>
      <div class="info info-two">
        <span>公司愿景</span>
        <div>服务至上、臻于未来</div>
        <div>值得信赖的专业数据中心技术服务提供商</div>
      </div>
    </div>
  </div>
</template>

<script>
import Img1 from '../../assets/images/about/img1-1.png'
import Img2 from '../../assets/images/about/img1-2.png'
import Img3 from '../../assets/images/about/img1-3.png'
import Img4 from '../../assets/images/about/img1-4.png'
import ImgMask from '../../assets/images/about/img-mask.png'

export default {
  data () {
    return {
      Img1,
      Img2,
      Img3,
      Img4,
      ImgMask
    }
  }
}
</script>

<style lang="less" scoped>
.item-btn {
  width: 96px;
  height: 28px;
  border-radius: 14px;
  background-color: #f45937;
  color: #fff;
  font-size: 9px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;

  @media (min-width: 1280px) and (max-width: 1680px){
    width: 144px;
    height: 42px;
    border-radius: 21px;
    font-size: 14px;
    line-height: 42px;
    margin-top: 30px;
  }
        
  @media screen and (min-width: 1920px){
    width: 192px;
    height: 56px;
    border-radius: 28px;
    font-size: 18px;
    line-height: 56px;
    margin-top: 40px;
  }
}
.item-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('../../assets/images/about/img1.png');
  background-size: 100% 100%;
  width: 100%;
  height: 390px;

  @media (min-width: 1280px) and (max-width: 1680px){
    height: 645px;
  }
        
  @media screen and (min-width: 1920px){
    height: 840px;
  }

  .info {
    background: rgba(255, 255, 255, .8);
    position: relative;
  }

  .info-one {
    width: 390px;
    height: 285px;
    text-align: left;
    padding: 20px;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 585px;
      height: 487.5px;
      padding: 30px;
    }
          
    @media screen and (min-width: 1920px){
      width: 780px;
      height: 630px;
      padding: 40px;
    }

    > span {
      font-size: 15px;
      color: #222222;
      font-weight: bold;

      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 22.5px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 30px;
      }
    }

    > p {
      font-size: 9px;
      color: #222222;
      text-align: left;
      padding: 10px 0px;

      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 13.5px;
        padding: 15px 0px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 18px;
        padding: 20px 0px;
      }
    }
  }

  .info-two {
    width: 300px;
    height: 202px;
    text-align: left;
    padding: 80px 20px 20px 20px;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 450px;
      height: 303px;
      padding: 120px 30px 30px 30px;
    }
          
    @media screen and (min-width: 1920px){
      width: 600px;
      height: 404px;
      padding: 160px 40px 40px 40px;
    }


    > span {
      font-size: 15px;
      color: #222222;
      font-weight: bold;
      margin-bottom: 60px;
      display: block;

      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 22.5px;
        margin-bottom: 90px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 30px;
        margin-bottom: 120px;
      }
    }

    > div {
      font-size: 12px;
      color: #222222;
      text-align: left;
      padding: 10px 0px;

      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 18px;
        padding: 15px 0px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 24px;
        padding: 20px 0px;
      }
    }
  }
}

.item-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  width: 100%;
  background: #eae7e7;

  @media (min-width: 1280px) and (max-width: 1680px){
    padding: 60px;
  }
        
  @media screen and (min-width: 1920px){
    padding: 80px;
  }

  &-item {
    position: relative;
    width: 150px;
    height: 180px;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 225px;
      height: 270px;
    }
          
    @media screen and (min-width: 1920px){
      width: 300px;
      height: 360px;
    }

    img {
      position: absolute;
      width: 150px;
      height: 180px;
      top: 0px;
      left: 0px;
      z-index: 1;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 225px;
        height: 270px;
      }
            
      @media screen and (min-width: 1920px){
        width: 300px;
        height: 360px;
      }

    }
    div {
      font-size: 15px;
      position: absolute;
      left: 30px;
      bottom: 20px;
      z-index: 2;
      color: #fff;
      padding: 4px 16px;
      border: 1px dashed #fff;

      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 22.5px;
        left: 45px;
        bottom: 30px;
        padding: 6px 24px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 30px;
        left: 60px;
        bottom: 40px;
        padding: 8px 32px;
      }
    }
  }
}
</style>